const PRODUCT_COMPARISON_ANCHOR = '#products';
const PRODUCT_COMPARISON_ANCHOR_PLANS = '#plans';

export { PRODUCT_COMPARISON_ANCHOR, PRODUCT_COMPARISON_ANCHOR_PLANS };
